namespace $ {
	
	export class $mol_window extends $mol_object {
		
		static size() {
			return {
				width: 1024,
				height: 768,
			}
		}
		
	}
	
}
